import { render, staticRenderFns } from "./SearchProductBtn.vue?vue&type=template&id=3bd2c30b&scoped=true"
import script from "./SearchProductBtn.vue?vue&type=script&lang=js"
export * from "./SearchProductBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd2c30b",
  null
  
)

export default component.exports